import { useTranslation } from 'react-i18next';
import * as S from './styled';

export function MainFuntion() {
  const { t } = useTranslation();

  const MAIN_CARD = [
    {
      image_url: `${process.env.PUBLIC_URL}/images/main-function/function-1.png`,
      text_1: t('main_function.text_1_1'),
      text_2: t('main_function.text_1_2'),
    },
    {
      image_url: `${process.env.PUBLIC_URL}/images/main-function/function-2.png`,
      text_1: t('main_function.text_2_1'),
      text_2: t('main_function.text_2_2'),
    },
    {
      image_url: `${process.env.PUBLIC_URL}/images/main-function/function-3.png`,
      text_1: t('main_function.text_3_1'),
      text_2: t('main_function.text_3_2'),
    },
    {
      image_url: `${process.env.PUBLIC_URL}/images/main-function/function-4.png`,
      text_1: t('main_function.text_4_1'),
      text_2: t('main_function.text_4_2'),
    },
  ];

  const LIST_CHECK = [t('main_function.text_7_1'), t('main_function.text_7_2'), t('main_function.text_7_3')];
  const ICON_CHECK = `${process.env.PUBLIC_URL}/images/main-function/tick.png`;

  return (
    <S.MainFunctionStyled>
      <S.MainTitleStyled>{t('main_function.text_1')}</S.MainTitleStyled>

      <S.MainWrapCardStyled className="MainWrapCardStyled">
        {MAIN_CARD.map((item, index) => (
          <S.MainItemCardStyled key={index}>
            <div className="image">
              <img src={item.image_url} alt={item.image_url} />
            </div>
            <div className="text-1">{item.text_1}</div>
            <div className="text-2">{item.text_2}</div>
          </S.MainItemCardStyled>
        ))}
      </S.MainWrapCardStyled>

      <S.DownloadStyled>
        <div className="left">
          <div className="download">{t('main_function.text_5')}</div>
          <div className="description-download">{t('main_function.text_6')}</div>

          <div className="list">
            {LIST_CHECK.map((item, index) => (
              <div className="item-list" key={index}>
                <img className="item-list-image" src={ICON_CHECK} alt={ICON_CHECK} />
                <span className="item-list-text">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="right">
          <div
            className="btn"
            onClick={() =>
              window.open(
                'https://apps.apple.com/us/app/ifridge-ai-food-assistant/id6740765901',
                '_blank',
                'noopener,noreferrer',
              )
            }
          >
            <img
              className="btn-ios"
              src={`${process.env.PUBLIC_URL}/images/main-function/download-ios.png`}
              alt="/images/main-function/tick.png"
            />
          </div>
          <div
            className="btn"
            onClick={() =>
              window.open('https://play.google.com/store/apps', '_blank', 'noopener,noreferrer')
            }
          >
            <img
              className="btn-android"
              src={`${process.env.PUBLIC_URL}/images/main-function/download-android.png`}
              alt="/images/main-function/tick.png"
            />
          </div>
        </div>
      </S.DownloadStyled>
    </S.MainFunctionStyled>
  );
}
